
import { computed, defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { ElNotification } from "element-plus";
import { useRouter } from "vue-router";
import store from "@/store";
import moment from "moment/moment";

export default defineComponent({
  name: "CustomerDetails",
  computed: {
    moment() {
      return moment;
    }
  },

  setup() {
    onMounted(() => {
      setCurrentPageTitle("Зээлдэгчийн дэлгэрэнгүй");
    });

    const role = computed(() => {
      return store.getters.getRoleNames;
    });

    return {
      role
    };
  },
  mounted() {
    if (
      this.role.includes("ROLE_MORE_TCUSTOMER") ||
      this.role.includes("ROLE_MORE_TLOAN") ||
      this.role.includes("ROLE_ADMIN")
    )
      this.getCustomerDetails();
    // if (this.role.includes("ROLE_NEW_USER") || this.role.includes("ROLE_ADMIN"))
  },
  data() {
    const router = useRouter();
    const identityno = this.b64DecodeUnicode(this.$route.params.id);

    const getLoanDetails = (row, detailType = "loan") => {
      const loanCode =
        detailType === "loanline"
          ? row?.loanlineCode || row?.loanlinecode || row
          : row?.loanCode || row?.loancode || row;
      const orgCode = row?.orgCode || row?.orgcode || row?.providerRegnum || "";
      const customerCode =
        row?.customerCode ||
        row?.customercode ||
        row?.identityNo ||
        (this as any).customer?.identityNo ||
        this.identityno ||
        "";
      const id = this.b64EncodeUnicode(
        `${loanCode}@${orgCode}@${customerCode}@${detailType}`
      );
      router.push({
        name: "refloandetails",
        params: { id: id }
      });
    };

    return {
      identityno,
      getLoanDetails,
      dataLoading: true,
      subDataLoading: true,
      tableSearch: "",
      modalSearch: "",
      expandedSections: {
        profile: true,
        loans: true,
        loanlines: false,
        relations: false,
        collaterals: false,
        lineCollaterals: false
      },
      customerDetailsNotFound: false,
      emptyText: "Өгөгдөл байхгүй байна.",
      isCitizen: false,
      customer: {
        id: "",
        createdDate: "",
        numofShareholderCustomers: "",
        createdUser: "",
        version: "",
        customerName: "",
        lastUpdateDate: "",
        lastUpdateUser: "",
        lastUpdatePatch: "",
        isForeign: "",
        legalStatus: "",
        numofShareholderOrgs: "",
        createdPatch: "",
        numofRelatedOrgs: "",
        identityNo: "",
        stateRegisterNo: "",
        status: "",
        lastName: "",
        isCitizen: "",
        numofRelatedCustomers: ""
      },
      customerDetails: {
        id: "",
        createdDate: "",
        phone: "",
        jobPhone: "",
        ceoRegnum: "",
        createdUser: "",
        ceoAddress: "",
        addressSoumDistrictCode: "",
        addressSoumDistrictName: "",
        addressZipcode: "",
        addressFull: "",
        ceoEmail: "",
        ceoIsforeign: "",
        familyNumofUnemployed: "",
        orgNumofEmployee: "",
        isEmployed: "",
        jobMail: "",
        version: "",
        addressApartmentName: "",
        addressBagKhorooCode: "",
        lastUpdateDate: "",
        lastUpdateUser: "",
        lastUpdatePatch: "",
        addressAimagCityName: "",
        ceoFamilyname: "",
        ceoPhone: "",
        createdPatch: "",
        addressAimagCityCode: "",
        ceoCivilId: "",
        jobName: "",
        identityNo: "",
        occupation: "",
        jobAddress: "",
        orgRating: "",
        ceoFirstname: "",
        status: "",
        birthDate: "",
        orgAgency: "",
        addressBagKhorooName: "",
        addressStreetName: "",
        addressRegionName: "",
        taxNumber: "",
        addressTownName: "",
        familyNumofMembers: "",
        orgCompanyType: "",
        email: "",
        ceoLastname: "",
        familyName: "",
        jobPosition: ""
      },
      selectedLoanCode: null,
      requiredData: [],
      customerRelations: [],
      collateralInformation: [],
      collateralLineInformation: [],
      collateralOwners: [],
      collateralLineOwners: [],
      loanInformation: [],
      loanSchedule: [],
      loanPayment: [],
      loanlineInformation: []
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toggleSection(section) {
      this.expandedSections[section] = !this.expandedSections[section];
    },
    filteredRows(source) {
      const rows = (this as any)[source] || [];
      const search = (this.tableSearch || "")
        .toString()
        .trim()
        .toLowerCase();

      if (!search) {
        return rows;
      }

      return rows.filter(row => {
        return Object.values(row || {}).some(value => {
          return String(value ?? "")
            .toLowerCase()
            .includes(search);
        });
      });
    },
    filteredModalRows(source) {
      const rows = (this as any)[source] || [];
      const search = (this.modalSearch || "")
        .toString()
        .trim()
        .toLowerCase();

      if (!search) {
        return rows;
      }

      return rows.filter(row => {
        return Object.values(row || {}).some(value => {
          return String(value ?? "")
            .toLowerCase()
            .includes(search);
        });
      });
    },
    async getCustomerDetails() {
      this.dataLoading = true;

      try {
        const res = await ApiService.get(
          "refcustomerdetails",
          `?identityno=${this.identityno}`
        );
        const result = res.data;

        if (result.code === 0) {
          ElNotification({
            title: "Алдаа",
            message: result.error,
            type: "error"
          });
        } else if (result.code === 2 || result.code === 401) {
          ElNotification({
            title: "Анхааруулга",
            message: result.warning,
            type: "warning"
          });
        } else {
          this.isCitizen = result.response.iscitizen;
          this.customer = result.response.customer;
          this.customerDetails = result.response.customerDetails;
          this.requiredData = result.response.annexInformation;
          this.customerRelations = result.response.customerRelations;
          this.loanInformation = result.response.loanInformation;
          this.loanlineInformation = result.response.loanlineInformation;
          this.collateralInformation = result.response.collateralInformation;
          this.collateralLineInformation =
            result.response.collateralLineInformation;
        }
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Өгөгдөл уншихад алдаа гарлаа.",
          type: "error"
        });
      } finally {
        this.dataLoading = false;
      }
    },
    async getLoanTransactions(loancode) {
      this.selectedLoanCode = loancode;
      this.modalSearch = "";
      this.subDataLoading = true;
      try {
        const res = await ApiService.get(
          "refloantransactions",
          `?loancode=${this.selectedLoanCode}`
        );
        const result = res.data;

        if (result.code === 0) {
          ElNotification({
            title: "Алдаа",
            message: result.error,
            type: "error"
          });
        } else if (result.code === 2 || result.code === 401) {
          ElNotification({
            title: "Анхааруулга",
            message: result.warning,
            type: "warning"
          });
        } else {
          this.loanPayment = result.response.loanPayment;
          this.loanSchedule = result.response.loanSchedule;
        }
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Өгөгдөл уншихад алдаа гарлаа.",
          type: "error"
        });
      } finally {
        this.subDataLoading = false;
      }
    },
    async getLoanCollaterals(collcode) {
      this.modalSearch = "";
      this.subDataLoading = true;
      try {
        const res = await ApiService.get(
          "refcolldetails",
          `?collcode=${collcode}`
        );
        const result = res.data;

        if (result.code === 0) {
          ElNotification({
            title: "Алдаа",
            message: result.error,
            type: "error"
          });
        } else if (result.code === 2 || result.code === 401) {
          ElNotification({
            title: "Анхааруулга",
            message: result.warning,
            type: "warning"
          });
        } else {
          this.collateralOwners = result.response.collOwners;
        }
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Өгөгдөл уншихад алдаа гарлаа.",
          type: "error"
        });
      } finally {
        this.subDataLoading = false;
      }
    },
    async getLoanLineCollaterals(collcode) {
      this.modalSearch = "";
      this.subDataLoading = true;
      try {
        const res = await ApiService.get(
          "reflinecolldetails",
          `?collcode=${collcode}`
        );
        const result = res.data;

        if (result.code === 0) {
          ElNotification({
            title: "Алдаа",
            message: result.error,
            type: "error"
          });
        } else if (result.code === 2 || result.code === 401) {
          ElNotification({
            title: "Анхааруулга",
            message: result.warning,
            type: "warning"
          });
        } else {
          this.collateralLineOwners = result.response.collOwners;
        }
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Өгөгдөл уншихад алдаа гарлаа.",
          type: "error"
        });
      } finally {
        this.subDataLoading = false;
      }
    }
  }
});
